// import { Grid, Paper } from '@mui/material';
// import {
//   //  useEffect,
//   useState
// } from 'react';
// // import Chart from 'react-apexcharts';
// import StoreView from './storeView';
// import TrendsChart from './TrendsViewCharts/Trendchart';

// const LineChartToggle = () => {
//   // const theme = useTheme();
//   const [activeButton, setActiveButton] = useState('Trends View');
//   const handleButtonClick = (button) => {
//     setActiveButton(button);
//   };

//   // const isSmallScreen = !useMediaQuery(theme.breakpoints.up('sm'));
//   // const isMediumScreen = !useMediaQuery(theme.breakpoints.up('md'));

//   // const data = {
//   //   VM: {
//   //     data: [42, 17, 89, 53, 78, 26, 61, 94, 12, 32, 69, 48, 85, 19, 73, 5, 91, 38, 67, 30, 75, 80, 40, 43, 56, 81],
//   //     dates: [
//   //       'Fri, Jan 5, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 6, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 7, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 8, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 9, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 10, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 11, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 12, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 13, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 14, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 15, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 16, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 17, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 18, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 19, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 20, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 21, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 22, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 23, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 24, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 25, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 26, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 27, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 28, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 29, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 30, 2024 00:00:00 GMT+0000'
//   //     ]
//   //   },
//   //   Anomalies: {
//   //     data: [68, 39, 74, 23, 56, 81, 12, 47, 60, 18, 85, 31, 42, 76, 50, 92, 28, 65, 10, 70, 45, 65, 76, 32, 78, 48],
//   //     dates: [
//   //       'Fri, Jan 5, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 6, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 7, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 8, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 9, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 10, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 11, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 12, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 13, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 14, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 15, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 16, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 17, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 18, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 19, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 20, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 21, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 22, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 23, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 24, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 25, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 26, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 27, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 28, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 29, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 30, 2024 00:00:00 GMT+0000'
//   //     ]
//   //   },
//   //   PoP: {
//   //     data: [88, 19, 72, 45, 31, 60, 83, 27, 55, 12, 69, 37, 80, 24, 50, 14, 91, 42, 75, 10, 93, 76, 43, 88, 32, 43],
//   //     dates: [
//   //       'Fri, Jan 5, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 6, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 7, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 8, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 9, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 10, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 11, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 12, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 13, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 14, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 15, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 16, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 17, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 18, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 19, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 20, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 21, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 22, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 23, 2024 00:00:00 GMT+0000',
//   //       'Wed, Jan 24, 2024 00:00:00 GMT+0000',
//   //       'Thu, Jan 25, 2024 00:00:00 GMT+0000',
//   //       'Fri, Jan 26, 2024 00:00:00 GMT+0000',
//   //       'Sat, Jan 27, 2024 00:00:00 GMT+0000',
//   //       'Sun, Jan 28, 2024 00:00:00 GMT+0000',
//   //       'Mon, Jan 29, 2024 00:00:00 GMT+0000',
//   //       'Tue, Jan 30, 2024 00:00:00 GMT+0000'
//   //     ]
//   //   }
//   // };
//   const currentDate = new Date();
//   const currentDay = currentDate.getDay();
//   const startOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
//   startOfWeek.setDate(currentDate.getDate() - currentDay - 3);

//   const endOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
//   endOfWeek.setDate(currentDate.getDate() + 2);

//   return (
//     <Grid item sx={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}>
//       <Paper
//         elevation={3}
//         sx={{
//           width: '100%',
//           height: 'auto',
//           padding: '20px',
//           marginBottom: '20px',
//           position: 'relative',
//           left: 'auto',
//           borderRadius: '15px'
//         }}
//       >
//         <div style={{ padding: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1%' }}>
//           <button
//             onClick={() => handleButtonClick('Trends View')}
//             style={{
//               backgroundColor: activeButton === 'Trends View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               borderRadius: '17px 0 0 17px',
//               marginRight: '3px',
//               width: '15%',
//               fontSize: '1rem'
//             }}
//           >
//             Trends View
//           </button>
//           <button
//             disabled
//             style={{
//               backgroundColor: activeButton === 'Store View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               marginRight: '3px',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'not-allowed',
//               opacity: 0.6
//             }}
//           >
//             Map View
//           </button>
//           {/* <button
//             disabled
//             style={{
//               backgroundColor: activeButton === 'Shelf View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               borderRadius: '0 17px 17px 0',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'not-allowed',
//               opacity: 0.6
//             }}
//           >
//             Camera view
//           </button> */}

//           <button
//             onClick={handleButtonClick}
//             style={{
//               backgroundColor: activeButton === 'Camera View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               borderRadius: '0 17px 17px 0',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'pointer'
//             }}
//           >
//             Camera view
//           </button>
//         </div>
//         {activeButton == 'Trends View' ? (
//           <div style={{ width: '100%', overflow: 'auto', height: '500px' }}>
//             {/* <Chart options={chartOptions} series={series} type="line" height={500} width={isSmallScreen || isMediumScreen ? 720 : '100%'} /> */}
//             <TrendsChart />
//             {/* <Grid
//               container
//               spacing={1}
//               style={{ marginLeft: isSmallScreen || isMediumScreen ? '5%' : '1.3%', marginTop: '-20px', flexWrap: 'nowrap', width: '97%' }}
//             >
//               {data.VM.dates.slice(-9).map((date, index) => (
//                 <Grid key={index} item xs={12} sm={6} md={3} sx={{ position: 'relative' }}>
//                   <Paper
//                     style={{
//                       padding: '10%',
//                       display: 'flex',
//                       border: '2px dotted ',
//                       borderRadius: '100%',
//                       height: '1%',
//                       width: '0.5%',
//                       backgroundColor:
//                         date == 'Tue, Jan 30, 2024 00:00:00 GMT+0000'
//                           ? '#C4C4C4'
//                           : date == 'Mon, Jan 29, 2024 00:00:00 GMT+0000'
//                           ? '#FF9500'
//                           : '#47EBEE',
//                       borderColor: '#00b3b3',
//                       position: 'relative'
//                     }}
//                   ></Paper>
//                   <Typography variant="body2" sx={{ marginTop: '10px' }}>
//                     {isSmallScreen ? new Date(date).toLocaleDateString() : new Date(date).toLocaleDateString()}
//                   </Typography>
//                   {index < data.VM.dates.slice(-9).length - 1 && (
//                     <Paper
//                       sx={{
//                         position: 'relative',
//                         flexGrow: '1',
//                         top: '-75%',
//                         transform: 'translateX(30%)',
//                         width: '79%',
//                         height: '10%',
//                         backgroundColor:
//                           date == 'Sun, Jan 28, 2024 00:00:00 GMT+0000'
//                             ? '#FF9500'
//                             : date == 'Mon, Jan 29, 2024 00:00:00 GMT+0000'
//                             ? '#C4C4C4'
//                             : '#00b3b3',
//                         content: '""',
//                         display: 'block',
//                         borderRadius: '0'
//                       }}
//                     />
//                   )}
//                 </Grid>
//               ))}
//             </Grid> */}
//           </div>
//         ) : (
//           <Grid>
//             <StoreView activeButton={activeButton} setActiveButton={setActiveButton} />
//           </Grid>
//         )}
//       </Paper>
//     </Grid>
//   );
// };

// export default LineChartToggle;

// import { Grid, Paper } from '@mui/material';
// import { useState, useEffect } from 'react';
// import StoreView from './storeView';
// import TrendsChart from './TrendsViewCharts/Trendchart';
// import axios from 'axios';

// const CameraHeatmapViewer = () => {
//   const [cameras, setCameras] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedCamera, setSelectedCamera] = useState(null);

//   useEffect(() => {
//     const fetchCameras = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.post('https://db.neophyte.live/sentinel-api/api/sentinel/getAllCameras');

//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }

//         const data = await response.json();
//         setCameras(data);
//         setLoading(false);
//       } catch (err) {
//         setError('Failed to fetch camera data');
//         setLoading(false);
//         console.error('Error fetching cameras:', err);
//       }
//     };

//     fetchCameras();
//   }, []);

//   const handleCameraClick = (camera) => {
//     setSelectedCamera(camera);
//   };

//   if (loading) {
//     return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>Loading camera data...</div>;
//   }

//   if (error) {
//     return <div style={{ color: 'red', padding: '16px', border: '1px solid #ffcccc', borderRadius: '4px' }}>{error}</div>;
//   }

//   return (
//     <div style={{ maxWidth: '100%', margin: '0 auto', padding: '16px' }}>
//       <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '16px' }}>Available Cameras</h2>

//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}>
//         {cameras.map((camera) => (
//           <button
//             key={camera._id}
//             onClick={() => handleCameraClick(camera)}
//             style={{
//               padding: '8px 16px',
//               borderRadius: '4px',
//               color: 'white',
//               backgroundColor: selectedCamera && selectedCamera._id === camera._id ? 'black' : 'gray',
//               border: 'none',
//               cursor: 'pointer'
//             }}
//           >
//             {camera.device_name}
//           </button>
//         ))}
//       </div>

//       {selectedCamera ? (
//         <div style={{ marginTop: '24px' }}>
//           <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '16px' }}>Heatmap for {selectedCamera.device_name}</h2>
//           <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px', maxWidth: '100%' }}>
//             <img
//               src={selectedCamera.heatmap}
//               alt={`Heatmap for ${selectedCamera.device_name}`}
//               style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = '/api/placeholder/800/450';
//                 e.target.alt = 'Heatmap image not available';
//               }}
//             />
//           </div>

//           <div style={{ marginTop: '16px', display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
//             <div style={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '4px' }}>
//               <h3 style={{ fontWeight: '500', marginBottom: '8px' }}>Camera Details</h3>
//               <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
//                 <li style={{ marginBottom: '4px' }}>
//                   <strong>ID:</strong> {selectedCamera._id}
//                 </li>
//                 <li style={{ marginBottom: '4px' }}>
//                   <strong>Store:</strong> {selectedCamera.store}
//                 </li>
//                 <li style={{ marginBottom: '4px' }}>
//                   <strong>Status:</strong> {selectedCamera.active ? 'Active' : 'Inactive'}
//                 </li>
//                 <li style={{ marginBottom: '4px' }}>
//                   <strong>Zones:</strong> {selectedCamera.zones.length}
//                 </li>
//                 <li>
//                   <strong>Created:</strong> {new Date(selectedCamera.created_at).toLocaleDateString()}
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             height: '300px',
//             backgroundColor: '#f5f5f5',
//             borderRadius: '4px',
//             border: '1px solid #e0e0e0'
//           }}
//         >
//           <p style={{ color: '#757575' }}>Select a camera to view its heatmap</p>
//         </div>
//       )}
//     </div>
//   );
// };

// const LineChartToggle = () => {
//   const [activeButton, setActiveButton] = useState('Trends View');

//   const handleButtonClick = (button) => {
//     setActiveButton(button);
//   };

//   const currentDate = new Date();
//   const currentDay = currentDate.getDay();
//   const startOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
//   startOfWeek.setDate(currentDate.getDate() - currentDay - 3);
//   const endOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
//   endOfWeek.setDate(currentDate.getDate() + 2);

//   return (
//     <Grid item sx={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}>
//       <Paper
//         elevation={3}
//         sx={{
//           width: '100%',
//           height: 'auto',
//           padding: '20px',
//           marginBottom: '20px',
//           position: 'relative',
//           left: 'auto',
//           borderRadius: '15px'
//         }}
//       >
//         <div style={{ padding: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1%' }}>
//           <button
//             onClick={() => handleButtonClick('Trends View')}
//             style={{
//               backgroundColor: activeButton === 'Trends View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               borderRadius: '17px 0 0 17px',
//               marginRight: '3px',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'pointer'
//             }}
//           >
//             Trends View
//           </button>
//           <button
//             disabled
//             style={{
//               backgroundColor: activeButton === 'Store View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               marginRight: '3px',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'not-allowed',
//               opacity: 0.6
//             }}
//           >
//             Map View
//           </button>
//           <button
//             onClick={() => handleButtonClick('Camera View')}
//             style={{
//               backgroundColor: activeButton === 'Camera View' ? 'black' : 'gray',
//               color: '#fff',
//               padding: '4px',
//               borderRadius: '0 17px 17px 0',
//               width: '15%',
//               fontSize: '1rem',
//               cursor: 'pointer'
//             }}
//           >
//             Camera view
//           </button>
//         </div>

//         {activeButton === 'Trends View' ? (
//           <div style={{ width: '100%', overflow: 'auto', height: '500px' }}>
//             <TrendsChart />
//           </div>
//         ) : activeButton === 'Camera View' ? (
//           <div style={{ width: '100%', overflow: 'auto', height: '500px' }}>
//             <CameraHeatmapViewer />
//           </div>
//         ) : (
//           <Grid>
//             <StoreView activeButton={activeButton} setActiveButton={setActiveButton} />
//           </Grid>
//         )}
//       </Paper>
//     </Grid>
//   );
// };

// export default LineChartToggle;








import { Grid, Paper } from '@mui/material';
import { useState, useEffect } from 'react';
import StoreView from './storeView';
import TrendsChart from './TrendsViewCharts/Trendchart';
import axios from 'axios';

const CameraHeatmapViewer = () => {
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);

  useEffect(() => {
    const fetchCameras = async () => {
      try {
        setLoading(true);
        const response = await axios.post('https://db.neophyte.live/sentinel-api/api/sentinel/getAllCameras');
        setCameras(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch camera data');
        setLoading(false);
        console.error('Error fetching cameras:', err);
      }
    };

    fetchCameras();
  }, []);

  const handleCameraClick = (camera) => {
    setSelectedCamera(camera);
  };

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>Loading camera data...</div>;
  }

  if (error) {
    return <div style={{ color: 'red', padding: '16px', border: '1px solid #ffcccc', borderRadius: '4px' }}>{error}</div>;
  }

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '16px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '16px' }}>Camera Heatmaps</h2>

      <div style={{ display: 'flex', gap: '24px' }}>
        {/* Left side - Camera list */}
        <div style={{ width: '25%', minWidth: '200px' }}>
          <div style={{ fontWeight: '500', marginBottom: '12px' }}>Select Camera</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '500px', overflowY: 'auto' }}>
            {cameras.map((camera) => (
              <button
                key={camera._id}
                onClick={() => handleCameraClick(camera)}
                style={{
                  padding: '10px 16px',
                  borderRadius: '4px',
                  color: 'white',
                  backgroundColor: selectedCamera && selectedCamera._id === camera._id ? 'black' : 'gray',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
              >
                {camera.device_name}
              </button>
            ))}
          </div>
        </div>

        {/* Right side - Heatmap display */}
        <div style={{ width: '75%', minWidth: '300px' }}>
          {selectedCamera ? (
            <div>
              <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '16px' }}>
                {selectedCamera.device_name} - Heatmap
              </h3>
              <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '8px', maxWidth: '100%' }}>
                <img
                  src={selectedCamera.heatmap}
                  alt={`Heatmap for ${selectedCamera.device_name}`}
                  style={{ width: '100%', height: 'auto', borderRadius: '4px' }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/api/placeholder/800/450';
                    e.target.alt = 'Heatmap image not available';
                  }}
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '300px',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px',
                border: '1px solid #e0e0e0'
              }}
            >
              <p style={{ color: '#757575' }}>Select a camera to view its heatmap</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const LineChartToggle = () => {
  const [activeButton, setActiveButton] = useState('Trends View');

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  const startOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
  startOfWeek.setDate(currentDate.getDate() - currentDay - 3);
  const endOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
  endOfWeek.setDate(currentDate.getDate() + 2);

  return (
    <Grid item sx={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}>
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          height: 'auto',
          padding: '20px',
          marginBottom: '20px',
          position: 'relative',
          left: 'auto',
          borderRadius: '15px'
        }}
      >
        <div style={{ padding: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1%' }}>
          <button
            onClick={() => handleButtonClick('Trends View')}
            style={{
              backgroundColor: activeButton === 'Trends View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              borderRadius: '17px 0 0 17px',
              marginRight: '3px',
              width: '15%',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Trends View
          </button>
          <button
            disabled
            style={{
              backgroundColor: activeButton === 'Store View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              marginRight: '3px',
              width: '15%',
              fontSize: '1rem',
              cursor: 'not-allowed',
              opacity: 0.6
            }}
          >
            Map View
          </button>
          <button
            onClick={() => handleButtonClick('Camera View')}
            style={{
              backgroundColor: activeButton === 'Camera View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              borderRadius: '0 17px 17px 0',
              width: '15%',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Camera view
          </button>
        </div>

        {activeButton === 'Trends View' ? (
          <div style={{ width: '100%', overflow: 'auto', height: '500px' }}>
            <TrendsChart />
          </div>
        ) : activeButton === 'Camera View' ? (
          <div style={{ width: '100%', overflow: 'auto', height: '500px' }}>
            <CameraHeatmapViewer />
          </div>
        ) : (
          <Grid>
            <StoreView activeButton={activeButton} setActiveButton={setActiveButton} />
          </Grid>
        )}
      </Paper>
    </Grid>
  );
};

export default LineChartToggle;